"use strict";

exports.__esModule = true;
exports.SessionError = void 0;
/*
 * COPYRIGHT 2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */
var SessionError = exports.SessionError = /*#__PURE__*/function () {
  function SessionError(utcTimestamp) {
    this.utcTimestamp = utcTimestamp;
  }

  /**
   * @return {string} the error as a Json string
   */
  var _proto = SessionError.prototype;
  _proto.toJsonString = function toJsonString() {
    return JSON.stringify(this);
  }

  /**
   * @returns {string} the time at which the error occurred, in ISO-8601 UTC. e.g. "2023-01-29T18:46:19Z".
   */;
  _proto.getUtcTimestamp = function getUtcTimestamp() {
    return this.utcTimestamp;
  };
  return SessionError;
}();